module.exports = __webpack_public_path__ + "static/img/icon_ww.da42fa17.png";